import jwt from "jsonwebtoken"

const tokenValid = (token) => {
    if (token && jwt.decode(token)) {
        return true
      }
      return false;
}

export default tokenValid